import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { FC, Suspense, useState, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Spinner } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';

import initI18n from './services/i18n';
import { configureStore } from './services/redux';
import { getBrandName } from './config';

const store = configureStore();

const ConnectedApp = lazy(() => {
  return import('./App');
});

const chooseVwBrand = (brand: string): string => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel';
    case 'vw':
      return 'vw6';
    case 'vwcv':
      return 'vw';
    case 'vwn':
      return 'vw';
    default:
      return brand;
  }
};

const PositionRestore: FC = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash && location.hash !== '') {
      setTimeout(() => {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [location]);

  return null;
};

const Init: FC = () => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    Promise.all([initI18n(getBrandName())]).then(() => {
      setLoaded(true);
    });
  }, []);
  return loaded ? (
    <Suspense fallback={<Spinner fullPage aria-label={t('app:loader:ariaLabel')} />}>
      {/* @ts-ignore */}
      <Provider store={store as any}>
        <Router>
          <PositionRestore />
          <ConnectedApp />
        </Router>
      </Provider>
    </Suspense>
  ) : null;
};

function render(): void {
  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Init />);
}

declare let module: { hot: any };

if (module.hot) {
  module.hot.accept(render);
}

render();
